export class IdDescription {
  id!: string;
  description!: string;
}
